import { useSyncExternalStore } from 'react'
import {
  getInFlightProductSourceUploadIdsForProduct,
  subscribeInFlightProductSourceUploads,
} from '@/features/product-catalog/lib/persistProductSourceUploadFailed'

export function useInFlightProductSourceUploadIds(
  productId: string
): readonly string[] {
  return useSyncExternalStore(
    subscribeInFlightProductSourceUploads,
    () => getInFlightProductSourceUploadIdsForProduct(productId),
    () => getInFlightProductSourceUploadIdsForProduct(productId)
  )
}
